// Central design tokens for the Agricola (GURO) public signature page. The CSS
// custom properties in the public-payment components mirror these values; keep
// them in sync. `logos.main`/`footer` point at the GURO SVG assets — until those
// are added to src/assets, the components fall back to assets/agricola/agricola-logo.svg.
export const agricolaGuroDesignConfig = {
  brand: 'agricola',
  name: 'Banco Agricola',
  sponsorKeys: ['BAES', 'AGRICOLA', 'BANCOAGRICOLA', 'bancoagricola', 'agricola', 'baes'],

  colors: {
    primary: '#2C2A29',
    secondary: '#FDDA24',
    accent: '#E9C512',
    background: '#F9F9FA',
    text: '#2C2A29',
    textSecondary: '#565554',
    onSecondary: '#2C2A29',
    border: '#E6E6E6',
    disabled: '#CCCCCC'
  },

  fonts: {
    primary: 'Arial',
    fallback: 'sans-serif',
    weights: {
      normal: 400,
      medium: 500,
      bold: 700
    }
  },

  logos: {
    main: 'assets/agricola-logo-guro-og.svg',
    footer: 'assets/agricola-logo-guro-bn.svg',
    poweredBy: 'https://storage.googleapis.com/muvit-microsite-prod.appspot.com/assets/Instacredit/Logos/poweredby-Asys.svg'
  },

  layout: {
    maxWidth: '1400px',
    cardRadius: '8px',
    signatureCanvasMaxWidth: '800px',
    signatureCanvasHeight: '350px'
  },

  shadows: {
    navbar: '0 1px 3px rgba(0, 0, 0, 0.1)',
    card: '0 2px 4px rgba(0, 0, 0, 0.1)'
  }
};
